import { useEffect, useState } from "react";
import axios from "axios";

const useNfuReportadosVSEntregados = (year, token,id_punto_generacion) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/punto_seginus/obtenerNfuReportadosVSEntregados`,
          {anio: year === "acumulado" ? "all" : year,
            id_punto_generacion: id_punto_generacion},
          {headers: { Authorization: token }}
        );
         
        setData(response.data); 
      } catch (error) {
         
      }
    };

    if (token && id_punto_generacion) { 
      fetchData();
    }
  }, [ year, token, id_punto_generacion]);

  return data;
};

export default useNfuReportadosVSEntregados;